// Document ready event
jQuery(document).ready(function ($) {
    /**
     * Create desktop slider if the count is greater than 3
     * Using Swiper
     */
    new Swiper(".latest-stories-list", {
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            767: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 30,
            }
        },
        scrollbar: {
            el: ".swiper-scrollbar",
        },
    });

    const customHeightButton = () => {
        var heightImage = $(".stories-item img").height();

        var ratio = 2;

        var top = heightImage / ratio;

        $(".latest-stories .swiper-button").css('top', top + 'px')
    }

    customHeightButton();
    $(window).resize(function () {
        customHeightButton();
    });
});